import { message, Table,  Button,  Form, Input, Radio, Space } from "antd";
import { useEffect, useRef, useState } from "react";
import useWebPost from "../../utils/useWebPost";
import FullHeightLayout from '../../components/FullHeightLayout';
import CustModal from "../../components/ShowModal";

function ComsList() {
    const webPost = useWebPost();
    const [modalVisible, setModalVisible] = useState('');
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);

    const [form] = Form.useForm();
    const [editingRecord, setEditingRecord] = useState(null);
    const [freshData, setFreshData] = useState(0);

    const loadingRef = useRef();
    useEffect(() => {
        const fetchItems = async () => {
            if (loadingRef.current) return;
            loadingRef.current = true;
            setLoading(true);
            try {
                const res = await webPost('getcomsname', {});
                if (res){
                    window['comsname'] = res;
                    setData(res);
                } 
            } catch (e) {
                setData([]);
            } finally {
                loadingRef.current = false;
                setLoading(false);
            }
        }
        fetchItems();
    }, [freshData]);

    const columns = [
        {
            title: '序号',
            dataIndex: 'xd',
            key: 'xd',
            width: 80,
            fixed: 'left',
            render: (text, record, rowIndex) => {
                return rowIndex + 1 ;
            },
        },
        { title: '单位名称', dataIndex: 'name', width: 320 },
        { title: '税号', dataIndex: 'tax_no', width: 140 },
        { title: '开户银行', dataIndex: 'khh', width: 140 },
        { title: '银行账号', dataIndex: 'yhzh', width: 140 },
        { title: '单位地址', dataIndex: 'dwdz', width: 140 },
        { title: '电话', dataIndex: 'phone', width: 140 },
        { title: '是否有效', dataIndex: 'is_deleted', width: 120, render:(t)=> t-1==0?'无效':'有效' },
        {
            title: '操作', dataIndex: 'op', width: 120, render: (_, rs) => {
                return <Button onClick={() => showModal(rs)}>修改</Button>
            }
        },

    ].filter(Boolean);

    const showModal = async (record = null) => {
        setEditingRecord(record);
        setModalVisible(true);
        if(record){
            form.setFieldsValue(record);
        }else{
            form.resetFields();
        }
    };

    const handleModalClose = () => {
        setModalVisible(false);
        setEditingRecord(null);
        form.resetFields();
    }
    const saveSubmit = async (values)=>{
        if (loadingRef.current) return;
        loadingRef.current = true;
        setLoading(false);
        try {
            const res = await webPost("savecoms", values);
            if (res) {
                setFreshData(Math.random());
                handleModalClose();
            }
        } catch (error) {
            console.error('Save failed:', error);
        } finally {
            loadingRef.current = false;
            setLoading(false);
        }
    }
    return (
        <FullHeightLayout
            headerContent={<Space size={'middle'}><Button onClick={showModal}>+ 新建</Button></Space>}
            bodyContent={
                <>
                    <Table
                        columns={columns}
                        dataSource={data}
                        rowKey="id"
                        loading={loading}
                        pagination={false}
                        bordered
                        scroll={{
                            x: 740,
                            y: 'calc(100vh - 300px)',
                        }}
                    />
                    <CustModal title={editingRecord?'修改单位信息':'新建单位信息'} open={modalVisible} onCancel={handleModalClose} footer={false}>
                        <Form form={form} layout="horizontal" onFinish={saveSubmit}  labelCol={{ span: 5 }} wrapperCol={{ span: 19 }}>
                            <Form.Item label="单位名称" name="name"><Input /></Form.Item>
                            <Form.Item label="税号" name="tax_no"><Input /></Form.Item>
                            <Form.Item label="开户银行" name="khh"><Input /></Form.Item>
                            <Form.Item label="银行账号" name="yhzh"><Input /></Form.Item>
                            <Form.Item label="单位地址" name="dwdz"><Input /></Form.Item>
                            <Form.Item label="电话" name="phone"><Input /></Form.Item>
                            <Form.Item label="是否有效" name="is_deleted"><Radio.Group><Radio value={'0'}>有效</Radio><Radio value={'1'}>无效</Radio></Radio.Group></Form.Item>
                            <Form.Item hidden name='id'><Input /></Form.Item>
                            <Form.Item label=" "><Button htmlType="submit" type="primary">保存</Button></Form.Item>
                        </Form>
                    </CustModal>
                </>
            }
            footerContent={null}
        />
    )
}


export default ComsList;
